<template>
    <DefaultTemplate :model="model">
        <div class="container">
            Login
        </div>
    </DefaultTemplate>
</template>

<script>


export default {
    props: ['model'],
    components: {

    }
};
</script>
